import script from "./quote-draft-card.vue?vue&type=script&setup=true&lang=js"
export * from "./quote-draft-card.vue?vue&type=script&setup=true&lang=js"

import "./quote-draft-card.vue?vue&type=style&index=0&id=fc665b5e&lang=css"

const __exports__ = script;

export default __exports__